module.exports = __webpack_public_path__ + "img/11.0d4a31d8.jpg";